// Load More functionality for collection pagination
class LoadMore {
  constructor() {
    this.init();
  }

  init() {
    const loadMoreContainer = document.querySelector('.load-more');
    if (!loadMoreContainer) return;

    this.container = loadMoreContainer;
    this.button = this.container.querySelector('.load-more__button');
    this.productGrid = document.querySelector('#product-grid');

    if (!this.button || !this.productGrid) return;

    this.#attachEventListeners();
  }

  #attachEventListeners() {
    this.button.addEventListener('click', () => this.#loadMore());
  }

  async #loadMore() {
    const nextUrl = this.button.dataset.nextUrl;
    if (!nextUrl) return;

    // Disable button and show loading state
    this.button.disabled = true;
    this.button.classList.add('load-more__button--loading');
    const originalText = this.button.textContent;
    this.button.textContent = 'Loading...';

    try {
      const response = await fetch(nextUrl);
      if (!response.ok) throw new Error('Network response was not ok');

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Get the new products
      const newProducts = doc.querySelectorAll('#product-grid > li');

      // Append new products to existing grid
      for (const product of newProducts) {
        this.productGrid.appendChild(product);
      }

      // Update the load more button
      const newLoadMore = doc.querySelector('.load-more');

      if (newLoadMore) {
        // There are more pages - update the button with new URL
        const newButton = newLoadMore.querySelector('.load-more__button');
        this.button.dataset.nextUrl = newButton.dataset.nextUrl;
        this.container.dataset.currentPage = newLoadMore.dataset.currentPage;

        // Re-enable button
        this.button.disabled = false;
        this.button.classList.remove('load-more__button--loading');
        this.button.textContent = originalText;
      } else {
        // No more pages - remove the button
        this.container.remove();
      }
    } catch (error) {
      console.error('Error loading more products:', error);

      // Re-enable button on error
      this.button.disabled = false;
      this.button.classList.remove('load-more__button--loading');
      this.button.textContent = originalText;
    }
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new LoadMore();
  });
} else {
  new LoadMore();
}
